'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalHeader = require('./ModalHeader.scss');

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalHeader = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(ModalHeader, _Component);

    function ModalHeader() {
        (0, _classCallCheck3.default)(this, ModalHeader);
        return (0, _possibleConstructorReturn3.default)(this, (ModalHeader.__proto__ || (0, _getPrototypeOf2.default)(ModalHeader)).apply(this, arguments));
    }

    (0, _createClass3.default)(ModalHeader, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['className', 'closeButton', 'content', 'contentClassName', 'hideLogo', 'logoClassName']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                closeButton = _props.closeButton,
                content = _props.content,
                contentClassName = _props.contentClassName,
                hideLogo = _props.hideLogo,
                logoClassName = _props.logoClassName,
                onHide = _props.onHide;


            var headerClass = (0, _classnames2.default)(className, _ModalHeader2.default.header);
            var logoClass = (0, _classnames2.default)(logoClassName, _ModalHeader2.default.logo);
            var contentClass = (0, _classnames2.default)(contentClassName, _ModalHeader2.default.content);

            return (0, _jsx3.default)('div', {
                className: headerClass
            }, void 0, closeButton && (0, _jsx3.default)('button', {
                className: _ModalHeader2.default['close-button'],
                onClick: onHide
            }, void 0, (0, _jsx3.default)('span', {}, void 0, '\xD7')), !hideLogo && (0, _jsx3.default)('img', {
                className: logoClass,
                src: 'https://p1.liveauctioneers.com/dist/images/logo.svg',
                alt: 'logo'
            }), content && (0, _jsx3.default)('span', {
                className: contentClass
            }, void 0, content));
        }
    }]);
    return ModalHeader;
}(_react.Component), _class.defaultProps = {
    className: '',
    closeButton: true,
    content: '',
    contentClassName: '',
    hideLogo: false,
    logoClassName: ''
}, _temp);
exports.default = ModalHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/Shared/ModalHeader.js
// module id = TFOM
// module chunks = 46